
'use strict'

if (process.env.NODE_ENV === 'production') {
  module.exports = require('./react-test-id.cjs.production.min.js')
} else {
  module.exports = require('./react-test-id.cjs.development.js')
}
